<template>
  <div>
    <span>
      Liste des agents affectés à la file : <strong>{{ fileName  }}</strong>
    </span>

    <ul class="agent-list">
      <li v-for="agent in agents" :key="agent.id" class="agent-item">
        <span>{{ agent.nom }} {{ agent.prenom }}</span>
        <button class="btn-remove" @click="confirmerRetirer(agent.id)">
          Retirer <i class="flaticon-delete"></i>
        </button>
      </li>
    </ul>

    <router-link class="btn btn-secondary mt-3" :to="{ name: 'ListeAffectationPage' }">
      Retour à la liste des affectations
    </router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "../../services/ApiService";
import { error, success } from "../../utils/utils";
import { useRoute } from "vue-router";
import Swal from "sweetalert2";

export default defineComponent({
  name: "RetirerAgent",
  props: {
    validationQueueId: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const agents = ref<Array<{ id: string; nom: string; prenom: string }>>([]);
    const route = useRoute();

    // On utilise le prop name ou un fallback
   
    const queueId = props.validationQueueId || (route.params.validationQueueId as string);
    const fileName = (route.query.name as string) || "Nom inconnu";

    const fetchAgents = async () => {
      try {
        const response = await ApiService.get(`/agvalidationqueue/${queueId}`);
        agents.value = response.data.data;
      } catch (err: any) {
        error(err?.response?.data?.message || "Erreur lors du chargement des agents");
      }
    };

    const retirerAgent = async (agentId: string) => {
      try {
        await ApiService.delete(`/agvalidationq/${agentId}/${queueId}`);
        success("Agent retiré de la file");
        agents.value = agents.value.filter(a => a.id !== agentId);
      } catch (err: any) {
        error(err?.response?.data?.message || "Impossible de retirer l'agent");
      }
    };

    // Fonction avec confirmation SweetAlert
    const confirmerRetirer = (agentId: string) => {
      Swal.fire({
        title: "Êtes-vous sûr ?",
        text: "Voulez-vous vraiment retirer cet agent de la file ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, retirer",
        cancelButtonText: "Annuler"
      }).then((result) => {
        if (result.isConfirmed) {
          retirerAgent(agentId);
        }
      });
    };

    onMounted(() => {
      fetchAgents();
    });

    return { agents, confirmerRetirer, fileName  };
  },
});
</script>

<style scoped>
.agent-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.agent-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s;
}

.agent-item:hover {
  background-color: #f9f9f9;
}

.btn-remove {
  background-color: #ff6b6b;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: background-color 0.2s, transform 0.15s;
}

.btn-remove i {
  font-size: 14px;
}

.btn-remove:hover {
  background-color: #ff4c4c;
  transform: scale(1.05);
}
</style>
